export default "__VITE_PUBLIC_ASSET__e30f1a09__"